<template>
  <div id="app">
    <template v-if="isRouterAlive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      isRouterAlive: true
    }
  },
  methods:{
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  }
}
</script>

<style>
html {
  height: 100%;
  background: #f8f8f8;
  -webkit-text-size-adjust:none;
}

.not-scroll {
    overflow: hidden;
}
.overflow{
  overflow: hidden;
  height:100%;
}
body {
  height: 100%;
  position: relative;
  min-height: 100%;
  max-width: 80rem;
  margin: auto;
  /*background: white;*/
}

body.condition-dialog-open {
  position: fixed;
  width: 100%;
}

* {
  /*-webkit-touch-callout:none;*/
  /*-webkit-user-select:none;
-khtml-user-select:none;
-moz-user-select:none;
-ms-user-select:none;
user-select:none;*/
}

*:focus {
  outline: none;
}

li {
  list-style-type: none;
}

input {
  border: none;
}

#app {
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  position: relative;
  font-size: 2.4rem;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}

em {
  font-style: normal;
}

.weui-picker {
  font-size: 2.4rem;
}

.weui-dialog__bd {
  font-size: 3rem !important;
  line-height: 3rem !important;
  padding: 3rem 2rem !important;
  text-align: center !important;
  border-bottom: 2px solid #f2f2f2 !important;
}

.weui-dialog__ft {
  font-size: 3.6rem !important;
  line-height: 3.6rem !important;
  text-align: center !important;
  padding: 2rem 0 !important;
}

.weui-toast {
  width: 30rem;
  height: auto;
  min-height: 15rem;
  margin-left: -15rem;
  z-index: 100000000;
}

.weui-toast__content {
  font-size: 2.8rem;
  margin-top: 2rem;
}

.weui-toptips {
  font-size: 3.2rem;
}

.weui-picker {
  z-index: 1111111111 !important;
}

.weui-picker__hd {
  /*background: red;*/
}

.more {
  position: fixed !important;
  bottom: 0;
}

.weui-mask {
  /*z-index: 1 !important;*/
}

.icon {
  /* 通过设置 font-size 来改变图标大小 */
  width: 1em;
  height: 1em;
  /* 图标和文字相邻时，垂直对齐 */
  vertical-align: -0.15em;
  /* 通过设置 color 来改变 SVG 的颜色/fill */
  fill: currentColor;
  /* path 和 stroke 溢出 viewBox 部分在 IE 下会显示
     normalize.css 中也包含这行 */
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// App.vue?19ad5d93